<template>
	<div class="bulletFrame-template">
		<div class="back_box">
			<i class="el-icon-arrow-left" @click="close_bulletFrame()"></i>
		</div>
		<div class="bulletFrame-content" :class="TypeName == 'search-user' ? 'SearchUserBox' : 'SidebarBox'">
			<Sidebar v-if="TypeName == 'sidebar'" @close_bulletFrame_fun="close_bulletFrame_fun"></Sidebar>
			<SearchUser v-if="TypeName == 'search-user'" @close_bulletFrame_fun="close_bulletFrame_fun"></SearchUser>
		</div>
		
	</div>
</template>

<script>
import Sidebar from '../Sidebar.vue';
import SearchUser from '../SearchUser.vue';

export default {
	name: 'bulletFrame',
	components: { Sidebar, SearchUser },

	props: {
		TypeName: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			open_a_menu: false,
			logoUrl: "https://www.tozostore.com/cdn/shop/files/tozo_logo_m_1600x.png?v=1720407847",
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
	mounted() {
	  // this.list = this.Post_List
	},
  
	methods:{
		close_bulletFrame(){
			this.$emit("close_bulletFrame")
		},
	
		close_bulletFrame_fun(){
			this.$emit("close_bulletFrame")
		},	
	  
		//查看 粉丝或关注人信息
		check_information(item){
			this.open_a_menu =! this.open_a_menu
		},
		//查看 搜索
		check_search(item){
			// this.open_a_menu =! this.open_a_menu
			this.$router.push({
			  name: "search-user",
			  // params: {
			  //   routeName: 'add' + '_' + '添加产品基本信息',
			  //   page: this.listQuery.page,
			  // }
			})
		},
	
		//查看 粉丝或关注人信息
		check_menu(item){
			// this.open_a_menu =! this.open_a_menu
			this.$router.push({
			  name: "Sidebar",
			  // params: {
			  //   routeName: 'add' + '_' + '添加产品基本信息',
			  //   page: this.listQuery.page,
			  // }
			})
		},
	
		logo_box(){
			let language = this.$language == "" || this.$language == "en" ? "" : `/${this.$language}`
			console.log(language)
			window.open(`https://www.tozostore.com${language}`, '_blank')
		},
	
		//查看详情
		view_details(item){
			console.log(item)
		},
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.bulletFrame-template{
		width: 100%;
		display: flex;
		justify-content: center;
		flex-direction: column;
		/* padding: 0px 10px; */
		background-color: #ffffff;
	}
	.back_box{
		width: 100%;
		display: flex;
		padding: 12px 10px;
		font-size: 24px;
		cursor: pointer;
		justify-content: flex-start;
	}
	.bulletFrame-content{
		width: 100%;
	}
	.SearchUserBox{
		min-height: 100vh;
	}
	.SidebarBox{
		border-bottom: 1px solid #f5f5f5;;
	}
	@media screen and (max-width: 1320px) {
	  
	}
</style>
